/**
 * Get the appliation currency.
 */
import { createSelector } from 'reselect';

import getApplicationSelector from '/business/shared/state/selectors/application/getApplicationSelector';

export default createSelector([getApplicationSelector], (application = null) => application?.offset?.offsetPercentage);
